import React from 'react';
import { CheckCircle2 } from 'lucide-react';

export const About = () => {
  const highlights = [
    'Fully managed from design to installation',
    'Experienced team',
    'High-quality materials',
    'Attention to detail'
  ];

  return (
    <section id="about" className="py-12 sm:py-16 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-8 sm:gap-12 lg:gap-16 items-center">
          {/* Content */}
          <div>
            <div className="inline-block px-3 sm:px-4 py-1.5 sm:py-2 bg-[#1c2536]/10 rounded-full mb-4 sm:mb-6">
              <span className="text-[#1c2536] font-semibold text-xs sm:text-sm">ABOUT US</span>
            </div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 leading-tight">
              Skilled Joinery You Can Trust
            </h2>
            <p className="text-base sm:text-lg text-gray-600 mb-4 sm:mb-6 leading-relaxed">
              Based in Brough, JP Joinery provides high quality carpentry and joinery for homes across East Yorkshire and surrounding areas.
            </p>
            <p className="text-base sm:text-lg text-gray-600 mb-6 sm:mb-8 leading-relaxed">
              From kitchen fitting and flooring to bespoke furniture and staircases, every project is completed with care, precision and attention to detail.
            </p>

            {/* Highlights */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
              {highlights.map((highlight, index) => (
                <div key={index} className="flex items-start space-x-2 sm:space-x-3 group">
                  <CheckCircle2 className="w-5 h-5 sm:w-6 sm:h-6 text-[#1c2536] flex-shrink-0 mt-0.5 group-hover:scale-110 transition-transform" />
                  <span className="text-sm sm:text-base text-gray-700 font-medium">{highlight}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Image */}
          <div className="relative mt-6 lg:mt-0">
            <div className="relative rounded-xl sm:rounded-2xl overflow-hidden shadow-xl sm:shadow-2xl aspect-[4/3]">
              <img 
                src="https://customer-assets.emergentagent.com/job_55c593a9-e2a5-421c-8db9-073c51e78637/artifacts/kiyniqly_van%20van%20van.jpeg"
                alt="JP Joinery Van"
                className="w-full h-full object-cover"
              />
              {/* Decorative overlay */}
              <div className="absolute inset-0 bg-gradient-to-tr from-[#1c2536]/10 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
